// extracted by mini-css-extract-plugin
module.exports = {"InputText_Label":"FormInputText_InputText_Label__2Q3lB","InputText_Wrapper":"FormInputText_InputText_Wrapper__39Hea","InputText_Input":"FormInputText_InputText_Input__1S_E6"};